<style scoped>
    .expense-group-header, .expense-group-footer{
        text-align: center;

        padding: 6px;
        height: 50px;
            line-height: 40px;
        position: relative;
    }
    .expense-select {
      position: absolute;
      left: 0;
    }
</style>
<template>
  <div>
    <Table
      :columns="columns"
      :data="expense_groups"
      :loading="loading"
      size="small"
    >
      <div
        slot="header"
        class="expense-group-header"
      >
        <div
          style="display:inline-block;"
          class="expense-select"
        >
          <Select
            v-model="params.payment_type"
            style="width:150px"
            @on-change="()=>{pageChange(1)}"
          >
            <Option
              v-for="item in payment_type_list"
              :key="item.val"
              :value="item.val"
            >
              {{ item.label }}
            </Option>
          </Select>
        </div>
        累计金额: {{ base_currency_name }}{{ format_total_price }},
        发票分配金额: {{ $util.formatPrice(allotted_total_price) }},
        发票总金额: {{ $util.formatPrice(invoice_total_price) }}
      </div>
      <div
        slot="footer"
        class="expense-group-footer"
      >
        <Page
          size="small"
          show-total
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>
    </Table>
  </div>
</template>
<script>
  import ExpenseUtil from '../../../libs/expense_util';
  import UserFlowBase from '../../components/flow/user_flow_base';
  import ViewerItem from '../../components/viewer/item';
  import InvoiceViewer from '../../invoice/components/invoice_viewer';
  import {mapGetters} from "vuex";
  export default {
    props: {
      relate: {
        type: String,
        required: true
      },
      relate_id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        payment_type_list: [
          {
            label: '全部',
            val: 'all'
          },
          {
            label: '报销',
            val:0
          },
          {
            label: '付款',
            val:1
          },
          {
            label: '预支',
            val:2
          },
          {
            label: '发票提交',
            val:8
          },
          {
            label: '账单提交',
            val:9
          }
        ],
        params: {
          page: 1,
          payment_type: 'all',
          relate: this.relate,
          relate_id: this.relate_id,
        },
        loading: false,
        expense_groups: [],
        total_price: 0,
        allotted_total_price: 0,
        invoice_total_price: 0,
        columns: [
          {
            title: '付款编号',
            key: 'uid',
            render: (h, params) => {
              const row = params.row;
              return h(ViewerItem, {
                props: {
                  model_id: row.id,
                  type: 'ExpenseGroup'
                },
                'class': {
                  'link': true
                }
              }, row.uid);
            }
          },
          {
            title: '付款名称',
            key: 'name'
          },
          {
            title: '付款金额',
            key: 'total_price',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_price));
            }
          },
          {
            title: '付款时间',
            key: 'desc',
            render: (h, params) => {
              const row = params.row;
              return h('span', row.paid_at || '-');
            }
          },
          {
            title: '状态',
            width: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name,
                    show_handles: false
                  }
                })
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '发票',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              return h(InvoiceViewer, {
                props: {
                  model: 'ExpenseGroup',
                  model_id: row.id
                }
              })
            }
          }
        ],
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        }
      }
    },
    computed: {
      ...mapGetters({
        companies_hash: 'async/companies_hash',
      }),
      base_currency_name() {
        if (this.expense_groups.length) {
          const company_id = this.expense_groups[0].company_id;
          const company = this.companies_hash[company_id];
          return company ? ExpenseUtil.getCurrencySymbol(company.base_currency) : '';
        } else {
          return '';
        }
      },
      format_total_price() {
        return this.$util.formatPrice(this.total_price);
      }
    },
    created() {
      this.getExpenseGroups();
    },
    mounted() {
      //
    },
    methods: {
      getExpenseGroups() {
        this.loading = true;
        const { payment_type, ...other } = this.params
        this.$util.ajax.get(this.$util.api.expense_group_relate, {
          params: {...other, payment_type:payment_type === 'all' ? undefined : payment_type}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.expense_groups = data.expense_groups;
            this.total_price = data.total_price;
            this.allotted_total_price = data.allotted_total_price;
            this.invoice_total_price = data.invoice_total_price;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getExpenseGroups();
      },
    }
  }
</script>
